import { ReactNode } from "react"

interface DroppableProps {
  droppableID: string | null
  children: ReactNode | ReactNode[]
  level: number
}

/**
 * Container for droppable table rows.
 * With dnd-kit, individual rows handle their own drop logic,
 * so this component just renders the container.
 */
export function Droppable({ children }: DroppableProps) {
  return <div className="treegrid__body">{children}</div>
}
